import { PositionItemProps } from "apis";
import { lazy } from "react";

export const PageAdminPosition = lazy(() => import("./List"));
export const PageAdminPositionCreate = lazy(() => import("./Add"));
export const PageAdminPositionUpdate = lazy(() => import("./Edit"));

export interface FormPositionValuesProps extends PositionItemProps { }